var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon__StyledIcon-sc-1det6wr-0 jgtlcI",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.42c.894 0 1.424 1.104 1.424 2.263V9.26c0 .356.178.624.445.802l6.685 3.654c.268.179.446.446.446.803v.575c0 .624-.624 1.07-1.159.802l-5.793-1.96a.486.486 0 00-.624.445v2.992c0 .357.178.539.445.717l1.694 1.07c.356.178.592.466.475.676-.026.048-.069.25-.315.304-.246.055-1.228-.176-2.665-.425l-.082-.012c-.244.583-.57.875-.976.875-.407 0-.735-.293-.983-.878a1.316 1.316 0 00-.075.011c-1.437.25-2.42.48-2.665.425-.246-.054-.289-.256-.315-.304-.117-.21.119-.498.475-.676l1.694-1.07c.267-.178.445-.535.445-.802v-2.992c0-.356-.356-.535-.624-.446L4.16 15.807C3.624 16.075 3 15.63 3 15.005v-.576c0-.267.178-.623.446-.712l6.685-3.655c.267-.178.445-.446.445-.802V5.594c0-1.337.53-2.174 1.424-2.174z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplate);
export default __webpack_public_path__ + "static/media/airplate.1c3f92a9bb88b4b5655deb12077c5ce6.svg";
export { ForwardRef as ReactComponent };